module.exports = __webpack_public_path__ + "img/promo-codes.dd2d2377.svg";